/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AffiliateInvoicesSuccessResponseResponse,
    ChargeAffiliateInvoice200,
    GetAffiliateInvoicesParams,
    RequestStatusResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get affiliate invoice history for a venue
 */
export const getAffiliateInvoices = (params?: GetAffiliateInvoicesParams, signal?: AbortSignal) => {
    return customInstance<AffiliateInvoicesSuccessResponseResponse>({
        url: `/affiliate-invoices`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAffiliateInvoicesQueryKey = (params?: GetAffiliateInvoicesParams) => {
    return [`/affiliate-invoices`, ...(params ? [params] : [])] as const;
};

export const getGetAffiliateInvoicesQueryOptions = <
    TData = Awaited<ReturnType<typeof getAffiliateInvoices>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetAffiliateInvoicesParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getAffiliateInvoices>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAffiliateInvoicesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAffiliateInvoices>>> = ({ signal }) =>
        getAffiliateInvoices(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAffiliateInvoices>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAffiliateInvoicesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAffiliateInvoices>>
>;
export type GetAffiliateInvoicesQueryError = APIErrorResponseResponse;

/**
 * @summary Get affiliate invoice history for a venue
 */

export function useGetAffiliateInvoices<
    TData = Awaited<ReturnType<typeof getAffiliateInvoices>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetAffiliateInvoicesParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getAffiliateInvoices>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetAffiliateInvoicesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Soft-delete an affiliate invoice
 */
export const deleteAffiliateInvoice = (invoiceId: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/affiliate-invoices/${invoiceId}`,
        method: 'DELETE',
    });
};

export const getDeleteAffiliateInvoiceMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteAffiliateInvoice>>,
        TError,
        { invoiceId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteAffiliateInvoice>>,
    TError,
    { invoiceId: number },
    TContext
> => {
    const mutationKey = ['deleteAffiliateInvoice'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteAffiliateInvoice>>,
        { invoiceId: number }
    > = (props) => {
        const { invoiceId } = props ?? {};

        return deleteAffiliateInvoice(invoiceId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteAffiliateInvoiceMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteAffiliateInvoice>>
>;

export type DeleteAffiliateInvoiceMutationError = APIErrorResponseResponse;

/**
 * @summary Soft-delete an affiliate invoice
 */
export const useDeleteAffiliateInvoice = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteAffiliateInvoice>>,
        TError,
        { invoiceId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteAffiliateInvoice>>,
    TError,
    { invoiceId: number },
    TContext
> => {
    const mutationOptions = getDeleteAffiliateInvoiceMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Send email for an affiliate invoice
 */
export const sendAffiliateInvoiceEmail = (id: number, signal?: AbortSignal) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/affiliate-invoices/${id}/send-email`,
        method: 'POST',
        signal,
    });
};

export const getSendAffiliateInvoiceEmailMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendAffiliateInvoiceEmail>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sendAffiliateInvoiceEmail>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['sendAffiliateInvoiceEmail'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sendAffiliateInvoiceEmail>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return sendAffiliateInvoiceEmail(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type SendAffiliateInvoiceEmailMutationResult = NonNullable<
    Awaited<ReturnType<typeof sendAffiliateInvoiceEmail>>
>;

export type SendAffiliateInvoiceEmailMutationError = APIErrorResponseResponse;

/**
 * @summary Send email for an affiliate invoice
 */
export const useSendAffiliateInvoiceEmail = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendAffiliateInvoiceEmail>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sendAffiliateInvoiceEmail>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getSendAffiliateInvoiceEmailMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Charge an affiliate invoice via Stripe
 */
export const chargeAffiliateInvoice = (id: number, signal?: AbortSignal) => {
    return customInstance<ChargeAffiliateInvoice200>({
        url: `/affiliate-invoices/${id}/charge`,
        method: 'POST',
        signal,
    });
};

export const getChargeAffiliateInvoiceMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof chargeAffiliateInvoice>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof chargeAffiliateInvoice>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['chargeAffiliateInvoice'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof chargeAffiliateInvoice>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return chargeAffiliateInvoice(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type ChargeAffiliateInvoiceMutationResult = NonNullable<
    Awaited<ReturnType<typeof chargeAffiliateInvoice>>
>;

export type ChargeAffiliateInvoiceMutationError = APIErrorResponseResponse;

/**
 * @summary Charge an affiliate invoice via Stripe
 */
export const useChargeAffiliateInvoice = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof chargeAffiliateInvoice>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof chargeAffiliateInvoice>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getChargeAffiliateInvoiceMutationOptions(options);

    return useMutation(mutationOptions);
};
